module.exports = __webpack_public_path__ + "img/Icon_awesome-check-circle.89598a1e.svg";